import { Box } from "@mui/material";
import { memo, useState } from "react";
import InfiniteScroll from "react-infinite-scroll-component";
import ContentTypeCardNew from "./contentTypeCard/ContentTypeCardNew";
import useContentGlleryStyle from "./contentTypeCard/DamContentGllery.style";
import LoaderComponent from "./LoaderComponent";

const DamContentCard = ({ fetchMoreData, rows, data, setImageData, assetType = "Image" }) => {
  const [selectedCardIndex, setSelectedCardIndex] = useState(null);
  const handleSelectCard = (index) => {
    setSelectedCardIndex(index);
  };
  const collectionLength = data.collectionItem.length;
  const classes = useContentGlleryStyle();

  return (
    <Box className={classes.noresultfoundtypo} id='scrollablegallerydiv'>
      <InfiniteScroll
        loader={
          <Box sx={{ width: "inherit" }}>
            <LoaderComponent />
          </Box>
        }
        next={fetchMoreData}
        hasMore={collectionLength % rows === 0}
        dataLength={collectionLength}
        scrollableTarget='scrollablegallerydiv'>
        {/* Masonry with mui has issues with flickering when lazy load of infinite scroll happens. Check for other options */}
        {/* <Box sx={{ width: "100%", minHeight: 829, marginTop: "16px" }}>
          <Masonry columns={isSmallScreen ? 1 : 4} spacing={2}>
            {data.collectionItem?.map((item) => (
              <ContentTypeCard
                key={item.uuid}
                content={item}
                selectedCardIndex={selectedCardIndex}
                onSelectCard={handleSelectCard}
                setImageData={setImageData}
              />
            ))}
          </Masonry>
        </Box> */}
        {data.collectionItem?.map((item) => (
          <ContentTypeCardNew
            key={item.uuid}
            content={item}
            selectedCardIndex={selectedCardIndex}
            onSelectCard={handleSelectCard}
            setImageData={setImageData}
            filterVal='default'
            assetType={assetType}
          />
        ))}
      </InfiniteScroll>
    </Box>
  );
};

export default memo(DamContentCard);
